export default class OnboardingPais {
    returnModel() {
        return {
          id: null,
          pais: null,
          empresa: null,
          divisao: null,
          localidade: null,
          cargo: null,
          posicao: null,
          centroCusto: null,
          dominioEmail: null,
          atributo: null,
          login: null,
          email: null,
          indicadorAprovado: null,
          informacoesAdicionais: null,
          dataAdmissaoPrevista: null,
          dataAdmissaoReal: null,
          dataCadastro: null,
          dataExclusao: null,
          dataExclusao: null,
          dataGeracaoEmail: null,
          justificativaCustomizacaoEmail: null
        }
    }
}